export const STATUS = {
  IDLE: "IDLE",
  PENDING: "PENDING",
  WAITING_ACTION: "WAITING_ACTION",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
};
